module.exports = __webpack_public_path__ + "media/images/bt-servico-cartorio-60b8dc81956789022b7a69e3a4a1902a.svg";